import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toggleMode } from 'redux/preferTheme/preferThemeSlice';
import { Prefer } from 'constants/prefer';
import { UserMenuHandle } from '../types/enums';

/**
 * @function usePrefer
 * @param {function} onHandleOpen
 * @returns {object}
 */
function usePrefer(onHandleOpen) {
	const dispatch = useDispatch();
	const themeMode = useSelector((state) => state.preferTheme.mode);

	const [mode, setMode] = useState(themeMode);

	const onMode = (newValue) => {
		if (newValue !== undefined) setMode(newValue);
	};

	const onSave = () => {
		localStorage.setItem(Prefer.Theme, JSON.stringify(mode));
		dispatch(toggleMode(mode));
		onHandleOpen(UserMenuHandle.ClosePrefer);
	};

	const state = { mode };

	const handler = { onMode, onSave };

	return { state, handler };
}

export default usePrefer;
